import React from 'react';
import { motion } from 'framer-motion';

export const AnimatedGradientDark: React.FC = () => {
  return (
    <div className="absolute inset-0 z-0 overflow-hidden">
      {/* Base gradient background - dark version */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-br from-[#05282C] via-[#0E666F] to-[#0A4A52]"
        animate={{
          background: [
            "linear-gradient(135deg, #05282C 0%, #0E666F 50%, #0A4A52 100%)",
            "linear-gradient(135deg, #0A4A52 0%, #05282C 50%, #0E666F 100%)",
            "linear-gradient(135deg, #0E666F 0%, #0A4A52 50%, #05282C 100%)",
            "linear-gradient(135deg, #05282C 0%, #0E666F 50%, #0A4A52 100%)"
          ]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Animated floating orbs - dark version */}
      <motion.div
        className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-[#0E666F]/50 to-[#0A4A52]/50 rounded-full blur-3xl"
        animate={{
          x: [0, 120, 0],
          y: [0, -60, 0],
          scale: [1, 1.6, 1],
          opacity: [0.3, 0.7, 0.3]
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      <motion.div
        className="absolute top-3/4 right-1/4 w-80 h-80 bg-gradient-to-r from-[#0A4A52]/50 to-[#05282C]/50 rounded-full blur-3xl"
        animate={{
          x: [0, -90, 0],
          y: [0, 70, 0],
          scale: [1, 1.2, 1],
          opacity: [0.4, 0.8, 0.4]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 2
        }}
      />

      <motion.div
        className="absolute bottom-1/4 left-1/3 w-72 h-72 bg-gradient-to-r from-[#05282C]/30 to-[#0E666F]/30 rounded-full blur-3xl"
        animate={{
          x: [0, 50, 0],
          y: [0, -30, 0],
          scale: [1, 1.2, 1],
          opacity: [0.2, 0.4, 0.2]
        }}
        transition={{
          duration: 7,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 4
        }}
      />

      {/* Subtle wave-like motion - dark version */}
      <motion.div
        className="absolute top-1/2 right-1/3 w-64 h-64 bg-gradient-to-r from-[#0E666F]/20 to-[#0A4A52]/20 rounded-full blur-2xl"
        animate={{
          x: [0, 30, 0],
          y: [0, 25, 0],
          scale: [1, 1.4, 1],
          opacity: [0.1, 0.3, 0.1]
        }}
        transition={{
          duration: 9,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }}
      />

      <motion.div
        className="absolute bottom-1/3 right-1/2 w-56 h-56 bg-gradient-to-r from-[#0A4A52]/20 to-[#05282C]/20 rounded-full blur-2xl"
        animate={{
          x: [0, -25, 0],
          y: [0, -15, 0],
          scale: [1, 0.8, 1],
          opacity: [0.2, 0.4, 0.2]
        }}
        transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 3
        }}
      />

      {/* Subtle overlay for depth - dark version */}
      <motion.div
        className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-black/10"
        animate={{
          opacity: [0.1, 0.3, 0.1]
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Animated mesh gradient - dark version */}
      <motion.div
        className="absolute inset-0 opacity-20"
        style={{
          background: `
            radial-gradient(circle at 20% 80%, rgba(14, 102, 111, 0.2) 0%, transparent 50%),
            radial-gradient(circle at 80% 20%, rgba(10, 74, 82, 0.2) 0%, transparent 50%),
            radial-gradient(circle at 40% 40%, rgba(5, 40, 44, 0.2) 0%, transparent 50%)
          `
        }}
        animate={{
          opacity: [0.1, 0.3, 0.1],
          scale: [1, 1.02, 1]
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      {/* Subtle particle effect */}
      <motion.div
        className="absolute inset-0"
        style={{
          backgroundImage: `
            radial-gradient(2px 2px at 20px 30px, rgba(222, 224, 224, 0.3), transparent),
            radial-gradient(2px 2px at 40px 70px, rgba(10, 74, 82, 0.3), transparent),
            radial-gradient(1px 1px at 90px 40px, rgba(5, 40, 44, 0.3), transparent),
            radial-gradient(1px 1px at 130px 80px, rgba(14, 102, 111, 0.3), transparent),
            radial-gradient(2px 2px at 160px 30px, rgba(10, 74, 82, 0.3), transparent)
          `,
          backgroundRepeat: 'repeat',
          backgroundSize: '200px 200px'
        }}
        animate={{
          opacity: [0.1, 0.4, 0.1],
          x: [0, 10, 0],
          y: [0, 5, 0]
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </div>
  );
};
